import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const statusDotVariants = cva('inline-block shrink-0 rounded-full size-2', {
  variants: {
    status: {
      green: 'bg-emerald-500',
      amber: 'bg-amber-500',
      red: 'bg-red-500',
      inactive: 'bg-muted-foreground',
      active: 'bg-purple-500',
    },
  },
  defaultVariants: {
    status: 'green',
  },
});

export interface StatusDotProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof statusDotVariants> {}

export function StatusDot({ status, className, ...props }: StatusDotProps) {
  return (
    <span
      className={cn(statusDotVariants({ status }), className)}
      aria-hidden={!props['aria-label']}
      {...props}
    />
  );
}
